import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
    AppLayout,
    Badge,
    Box,
    BreadcrumbGroup,
    Button,
    ColumnLayout,
    Container,
    Tabs,
    Grid,
    Header,
    HelpPanel,
    Icon,
    Modal,
    SpaceBetween,
    Spinner,
    Alert,
    Table,
    ExpandableSection,
    Flashbar,
    StatusIndicator,
    Link,
    Multiselect,
    TextContent,
    SideNavigation,
    FormField,
    Input,
    Select,
    Textarea,
    SegmentedControl,
    Checkbox,
    FileUpload
} from "@amzn/awsui-components-react";
import { getBoardItems, getBrassIsLDAPOwnerOf, addBoardItem, deleteBoardItem, deleteMultipleBoardItems, updateBoardItem, addOrUpdateBoardItemAnnouncement, updateSections, pushBoardItemToTeams } from "src/utilities/CloseAPIs"
import { configureGenericAppSync } from 'src/context/AuthContextUtility';
import { checkIfSupportAdmin, checkIfPortalAdmin } from 'src/checkPageAccess';
import { useSelector, useDispatch } from "react-redux";
import { isMemberOf } from "src/checkPageAccess";
import { getEmbedableContentBasedOnType, validateURLByWebResource, getWebResourcetype, cleanItemContent, getCleanedItemContent } from "../CloseHelperMethods"
import ErrorComponent from "../../../Ateam-BI/Templates/components/ErrorComponent";
import { TEMPLATE_APP, TEMPLATE_APP_PERMISSION, TEMPLATE_APP_TEAM, TEMPLATE_APP_OUTPUT, TEMPLATE_APP_ACCOUNTING, TEMPLATE_APP_USE_CASE, TEMPLATE_APP_SOURCE_DATA_TABLES, TEMPLATE_APP_CHART_OF_ACCOUNTS } from 'src/Ateam-BI/Templates/Constants';
import { API, graphqlOperation } from "aws-amplify";
import { useLocation, useHistory } from "react-router-dom";
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes, captureMetrics} from "src/katalMetrics/metricsHelperMethods"
import {uploadDocumentToVault} from "src/Ateam-BI/Vault/VaultAPIs"
import { tabTypes, STATIC_RESOURCES, ENV_SPECIFIC_RESOURCES } from '../constants';
import Bowser from "bowser";
import { v4 as uuidv4 } from 'uuid';
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';



function CustomMultipleResourcePage(props) {

    const [url, setURL] = useState();
    const [items, setItems] = useState([]);
    const [rawItems, setRawItems] = useState([]);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true)
    const [selectedOwner, setSelectedOwner] = useState(props?.owner)
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const currentUser = useSelector((globalState) => globalState.auth.userId)
    const [viewAccess, setViewAccess] = useState(props.viewAccess)
    const [addOrEditAccess, setAddOrEditAccess] = useState(props.addOrEditAccess)
    const [activeHref, setActiveHref] = useState(props.activeHref);
    const [activeHrefContent, setActiveHrefContent] = useState(<></>);
    const [errorText, setErrorText] = useState()
    const [visible, setVisible] = useState(false)
    const [adminResourceControlModalVisible, setAdminResourceControlModalVisible] = useState(false)
    const [announcementUpdateModalVisible, setAnnouncementUpdateModalVisible] = useState(false)
    const [selectedResourceType, setSelectedResourceType] = useState()
    const [addItemTitleInput, setAddItemTitleInput] = useState()
    const [addItemQSURLInput, setAddItemQSURLInput] = useState()
    const [addItemDescriptionInput, setAddItemDescriptionInput] = useState()
    const [addItemLinkInput, setAddItemLinkInput] = useState()
    const isPortalAdmin = useSelector((globalState) => globalState.auth.isPortalAdmin)
    const isSupportAdmin = useSelector((globalState) => globalState.auth.isSupportAdmin)
    const [selectedSegmentId, setSelectedSegmentId] = useState("add")
    const [selectedSectionsSegmentId, setSelectedSectionsSegmentId] = useState("add-section")
    const [selectedUpdateOrDeleteItem, setSelectedUpdateOrDeleteItem] = useState()
    const [selectedMultipleDeleteItems, setSelectedMultipleDeleteItems] = useState([])
    const [selectedResourceToPush, setSelectedResourceToPush] = useState()
    const [selectedLeftItemToDisplay, setSelectedLeftItemToDisplay] = useState()
    const [currentCarouselItems, setCurrentCarouselItems] = useState([])
    const [carousel, setCarousel] = useState({})
    const [apps, setApps] = useState([])
    const [selectedACApp, setSelectedACApp] = useState()
    const [leftMenuCollapsed, setLeftMenuCollapsed] = useState(false)
    const[boardItemAnnouncement, setBoardItemAnnouncement] = useState()
    const [gridDefinitions, setGridDefinitions] = useState([{ colspan: 2 }, { colspan: 10 }])
    const history = useHistory()
    const search = useLocation().search
    const searchParams = new URLSearchParams(search)
    const [sideSections, setSideSections] = useState([])
    const [selectedSection, setSelectedSection] = useState()
    const [selectedSectionToMoveTo, setSelectedSectionToMoveTo] = useState()
    const [createNewSectionChecked, setCreateNewSectionChecked] = useState(false)
    const [newSectionName, setNewSectionName] = useState()
    const [allGroupedItems, setAllGroupedItems] = useState()
    const [selectedOptionsToUpdateSection, setSelectedOptionsToUpdateSection] = useState([])
    const [file, setFile] = useState([])
    const ln = useLocation()
    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : currentUser,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}${location.search}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
        ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.CLOSE_PORTAL,[ln.search]);

    useEffect(() => {
        loadData()
    }, [selectedOwner, currentStage, currentUser])

 useEffect(() => {
         return () => {
      // Perform cleanup here, e.g., clear timers or unsubscribe from events
    };
    }, [])

    useEffect(() => {
        setSelectedSection()
        setNewSectionName()
        setSelectedOptionsToUpdateSection()
        setSelectedSectionToMoveTo()
    },[createNewSectionChecked, selectedSegmentId, selectedSectionsSegmentId])
    
    useEffect(() => {
        setActiveHref()
        setActiveHrefContent()
        setSelectedLeftItemToDisplay()
        props?.resetHref()
        setSelectedOwner(props?.owner)
    }, [props?.owner])

    useEffect(()=>{
        setViewAccess(props.viewAccess)
    },[props.viewAccess])

    useEffect(()=>{
        setAddOrEditAccess(props.addOrEditAccess)
    },[props.addOrEditAccess])

    useEffect(() => {
        if(props?.activeHref) {
            setActiveHref(props?.activeHref)
        } else if (searchParams.get(`resourceId`)){
            const found = rawItems?.find((item) => item?.board_item_id === searchParams.get(`resourceId`))
            if (rawItems?.length && found) {
                setActiveHref(found?.board_item_id)
            } else if (rawItems?.length) {
                searchParams.delete(`resourceId`)
                history.replace({
                ...history.location.search,
                search: `${searchParams.toString()}`,
                })
            }
        }
        else if(rawItems?.length && !props?.activeHref && !activeHref){
            const found = rawItems?.find((item) => item?.board_item_content_type !== 'EXTERNAL-LINK')
            if (found) {
                setActiveHref(found?.board_item_id)
            }
        }
    }, [props?.activeHref, rawItems])

    useEffect(() => {
        if (selectedUpdateOrDeleteItem?.contentType === 'QUICKSIGHT' || (selectedUpdateOrDeleteItem?.contentType === 'WEBPAGE' && selectedUpdateOrDeleteItem?.currentContent?.hasOwnProperty('description'))) {
            setAddItemQSURLInput(selectedUpdateOrDeleteItem?.currentContent?.url)
            setAddItemDescriptionInput(getCleanedItemContent(selectedUpdateOrDeleteItem?.currentContent?.description ? selectedUpdateOrDeleteItem?.currentContent?.description : ''))
            setAddItemTitleInput(selectedUpdateOrDeleteItem?.label)
        } else if (selectedUpdateOrDeleteItem?.contentType === 'EXTERNAL-LINK') {
            setAddItemLinkInput(selectedUpdateOrDeleteItem?.currentContent?.link)
            setAddItemTitleInput(selectedUpdateOrDeleteItem?.label)
        } else if (selectedUpdateOrDeleteItem?.contentType === 'WEBPAGE') {
            setAddItemTitleInput(selectedUpdateOrDeleteItem?.label)
            setAddItemLinkInput(selectedUpdateOrDeleteItem?.currentContent?.url)
        }
    }, [selectedUpdateOrDeleteItem])

    useEffect(()=>{
        setBoardItemAnnouncement(selectedLeftItemToDisplay?.board_item_announcement)
    },[selectedLeftItemToDisplay])

    useEffect(() => {
        if (activeHref) {
            setActiveHrefContent()
            searchParams.delete(`resourceId`)
            searchParams.append(`resourceId`, activeHref)
            history.replace({
                ...history.location.search,
                search: `${searchParams.toString()}`,
            })
            const item = rawItems.find((item) => item?.board_item_id === activeHref)
            if (item) {
                const jsonContent = JSON.parse(item?.board_item_content?.replaceAll("'", '"'))
                getEmbedableContentBasedOnType(jsonContent, item?.board_item_content_type, props?.tabType,{"owner_id": selectedOwner.value}).then((result) => {
                    setActiveHrefContent(result)
                })
                setSelectedLeftItemToDisplay(item)
                capturePageVisitMetricsForCPResources()
            }

        }
    }, [activeHref, items])

    useEffect(()=> {
        setAddItemTitleInput()
        setAddItemLinkInput()
        setAddItemDescriptionInput()
        setSelectedResourceType()
        setAddItemQSURLInput()
        setSelectedUpdateOrDeleteItem()
        setSelectedACApp()
    },[selectedSegmentId])

    useEffect(()=>{
        if(leftMenuCollapsed === true) {
            setGridDefinitions([{ colspan: 12 }])
        } else {
            setGridDefinitions([{ colspan: 2 }, { colspan: 10 }])
        }
    },[leftMenuCollapsed])


    const groupBySection = (items) => {
    return items.reduce((acc, item) => {
      const section = item.section || 'Other';
      if (!acc[section]) {
        acc[section] = [];
      }
      acc[section].push(item);
      return acc;
    }, {});
  };

    const loadData = async (href = undefined) => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        setShowLoadingIcon(true)
        await Promise.all([
        new Promise((resolve, reject) => {
            getBoardItems(props?.pageType, props?.owner?.value, tabTypes.LIST, function onSuccess(result) {
        let data = result.data.getBoardItemsRDS
        data = JSON.parse(data)
        setRawItems(data)
        const groupedItems = groupBySection(data)
        setAllGroupedItems(groupedItems)
        setSideSections(Object.keys(groupedItems).map((sectionName) => ({ label: sectionName, value: sectionName })))
        const sideItems = Object.entries(groupedItems).map(([sectionName, sectionItems]) => ({
                type: "section",
                text: sectionName,
                items: sectionItems.map(item => {
                const jsonContent = JSON.parse(item?.board_item_content?.replaceAll("'", '"'))
                const sideItem = {}
                if (item?.board_item_content_type === 'EXTERNAL-LINK') {
                    sideItem["href"] = jsonContent?.link
                    sideItem["text"] = item?.board_item_title
                    sideItem["type"] = "link"
                    sideItem["external"] = true
                } else {
                    sideItem["href"] = item?.board_item_id
                    sideItem["text"] = item?.board_item_title
                    sideItem["type"] = "link"
                }
                    return sideItem
                })
            }));
            
            setItems(sideItems)

            if(href) {
                setActiveHref(href)
            }
            setShowLoadingIcon(false)

            configureGenericAppSync()
            resolve();
        }, function onFailure(response) {
            configureGenericAppSync()
            setShowLoadingIcon(false)
            reject();
        })
        })])
        
        setCarouselItems();
    } finally {
        if(!pageLoadTime.isStopped) {
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, currentUser, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.CLOSE_PORTAL)
        }
    }
    }

    const capturePageVisitMetricsForCPResources = () => {
        const browser = Bowser.getParser(window.navigator.userAgent);
                const metricConfig = [{
                    metricName : 'actionPerformedBy',
                    metricValue : currentUser,
                    metricType : METRIC_TYPE.STRING,
                    isMonitor : true
                },
                {
                    metricName : 'visitedPagePath',
                    metricValue : `${ln.pathname}${location.search}`,
                    metricType : METRIC_TYPE.STRING,
                    isMonitor : true
                },
                {
                    metricName : 'browserName',
                    metricValue : browser.getBrowserName(),
                    metricType : METRIC_TYPE.STRING,
                    isMonitor : true
                },
                {
                    metricName : 'operatingSystem',
                    metricValue : browser.getOSName(),
                    metricType : METRIC_TYPE.STRING,
                    isMonitor : true
                },
                {
                    metricName : 'visitCount',
                    metricValue : 1,
                    metricType : METRIC_TYPE.COUNTER,
                    isMonitor : true
                }]
                captureMetrics(ACTION_METHODS.PAGE_VISIT, metricConfig, SITE_SERVICES.CLOSE_PORTAL)
    }

    const addItem = async () => {
        if (selectedResourceType?.value) {
            if((!createNewSectionChecked && !selectedSection?.value) || (createNewSectionChecked && !newSectionName)) {
                setErrorText("All fields are required!")
                return;
            }
            if ((selectedResourceType?.value === 'QUICKSIGHT' || selectedResourceType?.value === 'AMAZON-BI-QS') && addItemQSURLInput && addItemTitleInput && addItemDescriptionInput) {
                if (!(addItemQSURLInput.includes("https://") && addItemQSURLInput.includes("quicksight") && addItemQSURLInput.includes("dashboards"))) {
                    setErrorText("Please enter a valid Quicksight dashboard URL")
                    return
                }
                if (selectedResourceType?.value === 'AMAZON-BI-QS') {
                    if(!addItemQSURLInput.includes("embed")) {
                       setErrorText("Please enter a valid Embeddable Quicksight dashboard URL")
                       return 
                    }
                }
                setShowLoadingIcon(true)
                let content = {}
                content["url"] = addItemQSURLInput
                content["description"] = cleanItemContent(addItemDescriptionInput)

                content = JSON.stringify(content)
                content = content.replaceAll('"', "'")
                let columnOffset = {
                    "4": 0,
                    "6": 0
                }
                columnOffset = JSON.stringify(columnOffset)
                columnOffset = columnOffset.replaceAll('"', "'")
                const isDefault = selectedOwner?.owner_type === "DEFAULT"
                const input = {
                    "board_item_title": addItemTitleInput,
                    "board_item_content": content,
                    "board_item_content_type": selectedResourceType?.value === 'QUICKSIGHT' ? "QUICKSIGHT" : "WEBPAGE",
                    "owner_id": selectedOwner?.value,
                    "is_default": isDefault,
                    "board_page_type": props?.pageType,
                    "created_by": currentUser,
                    "last_updated_by": currentUser,
                    "row_span": "2",
                    "column_span": "1",
                    "column_offset": columnOffset,
                    "row_order": items?.length + 1,
                    "section": createNewSectionChecked ? newSectionName : selectedSection?.value
                }
                await addBoardItem(input, function onSuccess(result) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedResourceType()
                    setAddItemQSURLInput()
                    setErrorText()
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    loadData()
                    configureGenericAppSync()
                }, function onFailure(response) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    configureGenericAppSync()
                    setShowLoadingIcon(false)
                })

            } else if ((selectedResourceType?.value === 'EXTERNAL-LINK' && addItemLinkInput && addItemTitleInput) || 
            (selectedResourceType?.value === 'PDF' && file?.length > 0 && addItemTitleInput)) {
                setShowLoadingIcon(true)
                const fileId = uuidv4();
                let content = {}
                if(selectedResourceType?.value === 'EXTERNAL-LINK') {
                    content["link"] = addItemLinkInput
                } else if (selectedResourceType?.value === 'PDF') {
                    content["file_id"] =   fileId          
                }

                content = JSON.stringify(content)
                content = content.replaceAll('"', "'")
                let columnOffset = {
                    "4": 0,
                    "6": 0
                }
                columnOffset = JSON.stringify(columnOffset)
                columnOffset = columnOffset.replaceAll('"', "'")
                const isDefault = selectedOwner?.owner_type === "DEFAULT"
                const input = {
                    "board_item_title": addItemTitleInput,
                    "board_item_content": content,
                    "board_item_content_type": selectedResourceType?.value === 'EXTERNAL-LINK' ? "EXTERNAL-LINK" : "PDF",
                    "owner_id": selectedOwner?.value,
                    "is_default": isDefault,
                    "board_page_type": props?.pageType,
                    "created_by": currentUser,
                    "last_updated_by": currentUser,
                    "row_span": "2",
                    "column_span": "1",
                    "column_offset": columnOffset,
                    "row_order": items?.length + 1,
                    "section": createNewSectionChecked ? newSectionName : selectedSection?.value
                }
                if(selectedResourceType?.value === "PDF") {
                    await uploadDocumentToVault("pdf", VAULT_SERVICES.CLOSE_PORTAL, {"file_id": fileId, "owner_id": selectedOwner?.value}, file[0])
                }
                await addBoardItem(input, function onSuccess(result) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedResourceType()
                    setSelectedUpdateOrDeleteItem()
                    setSelectedSegmentId('add')
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    setErrorText()
                    setFile([])
                    loadData()
                    configureGenericAppSync()
                }, function onFailure(response) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedSegmentId('add')
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    setSelectedUpdateOrDeleteItem()
                    configureGenericAppSync()
                    setFile([])
                    setShowLoadingIcon(false)
                })
            } else if(selectedResourceType?.value === 'ACCOUNTING-CENTRAL-APP' && selectedACApp && addItemTitleInput) {

                setShowLoadingIcon(true)

                let content = {}
                let stage = currentStage === 'prod' ? '' : 'beta.'
                let url;
                if(selectedACApp?.customURL && selectedACApp?.customURL?.trim() !== '') {
                    url = `https://${stage}bi-central.accounting.amazon.dev${selectedACApp?.customURL}`
                } else {
                    url = `https://${stage}bi-central.accounting.amazon.dev/App/${selectedACApp?.value}`
                }
                content["url"] = url

                content = JSON.stringify(content)
                content = content.replaceAll('"', "'")
                let columnOffset = {
                    "4": 0,
                    "6": 0
                }
                columnOffset = JSON.stringify(columnOffset)
                columnOffset = columnOffset.replaceAll('"', "'")
                const isDefault = selectedOwner?.owner_type === "DEFAULT"
                const input = {
                    "board_item_title": addItemTitleInput,
                    "board_item_content": content,
                    "board_item_content_type": "WEBPAGE",
                    "owner_id": selectedOwner?.value,
                    "is_default": isDefault,
                    "board_page_type": props?.pageType,
                    "created_by": currentUser,
                    "last_updated_by": currentUser,
                    "row_span": "2",
                    "column_span": "1",
                    "column_offset": columnOffset,
                    "row_order": items?.length + 1,
                    "section": createNewSectionChecked ? newSectionName : selectedSection?.value
                }
                await addBoardItem(input, function onSuccess(result) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedResourceType()
                    setSelectedUpdateOrDeleteItem()
                    setSelectedSegmentId('add')
                    setErrorText()
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    loadData()
                    configureGenericAppSync()
                }, function onFailure(response) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedSegmentId('add')
                    setSelectedUpdateOrDeleteItem()
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    configureGenericAppSync()
                    setShowLoadingIcon(false)
                })

            } else if ((((selectedResourceType?.value === 'WIKI' ||
                 selectedResourceType?.value === 'SIM' ||
                 selectedResourceType?.value === 'BROADCAST' || 
                 selectedResourceType?.value === 'CEDRIC-PERSONA' || 
                 selectedResourceType?.value === 'WEBPAGE' ||
                 selectedResourceType?.value === 'ACR' || 
                 selectedResourceType?.value === 'MAGNIFY') && addItemLinkInput) || (Object.keys(STATIC_RESOURCES).includes(selectedResourceType?.value) || Object.keys(ENV_SPECIFIC_RESOURCES).includes(selectedResourceType?.value))) &&  addItemTitleInput) {
                
                if (Object.keys(STATIC_RESOURCES).includes(selectedResourceType?.value) || Object.keys(ENV_SPECIFIC_RESOURCES).includes(selectedResourceType?.value) || validateURLByWebResource(addItemLinkInput, selectedResourceType?.value)) {
                    
                setShowLoadingIcon(true)
                let content = {}
                let stage = currentStage === 'prod' ? '' : 'beta.'
                content["url"] = Object.keys(STATIC_RESOURCES).includes(selectedResourceType?.value) ? 
                                 STATIC_RESOURCES[selectedResourceType?.value] : 
                                 Object.keys(ENV_SPECIFIC_RESOURCES).includes(selectedResourceType?.value) ?
                                 ENV_SPECIFIC_RESOURCES[selectedResourceType?.value][currentStage] :
                                 addItemLinkInput

                content = JSON.stringify(content)
                content = content.replaceAll('"', "'")
                let columnOffset = {
                    "4": 0,
                    "6": 0
                }
                columnOffset = JSON.stringify(columnOffset)
                columnOffset = columnOffset.replaceAll('"', "'")
                const isDefault = selectedOwner?.owner_type === "DEFAULT"
                const input = {
                    "board_item_title": addItemTitleInput,
                    "board_item_content": content,
                    "board_item_content_type": "WEBPAGE",
                    "owner_id": selectedOwner?.value,
                    "is_default": isDefault,
                    "board_page_type": props?.pageType,
                    "created_by": currentUser,
                    "last_updated_by": currentUser,
                    "row_span": "2",
                    "column_span": "1",
                    "column_offset": columnOffset,
                    "row_order": items?.length + 1,
                    "section": createNewSectionChecked ? newSectionName : selectedSection?.value
                }
                await addBoardItem(input, function onSuccess(result) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedResourceType()
                    setSelectedUpdateOrDeleteItem()
                    setSelectedSegmentId('add')
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    setErrorText()
                    loadData()
                    configureGenericAppSync()
                }, function onFailure(response) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedSegmentId('add')
                    setSelectedUpdateOrDeleteItem()
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    configureGenericAppSync()
                    setShowLoadingIcon(false)
                })

                } else {
                    setErrorText('Please provide a valid URL with respect to resource')
                }
            
            } 
            else {
                setErrorText('All fields are required!')
            }

        } else {
            setErrorText('All fields are required!')
        }
    }

    const updateItem = async () => {
        if (selectedUpdateOrDeleteItem?.value) {
            if ((selectedUpdateOrDeleteItem?.contentType === 'QUICKSIGHT' || (selectedUpdateOrDeleteItem?.contentType === 'WEBPAGE' && selectedUpdateOrDeleteItem?.currentContent?.hasOwnProperty('description'))) && addItemQSURLInput && addItemDescriptionInput && addItemTitleInput) {
                if (!(addItemQSURLInput.includes("https://") && addItemQSURLInput.includes("quicksight") && addItemQSURLInput.includes("dashboards"))) {
                    setErrorText("Please enter a valid Quicksight dashboard URL")
                    return
                }
                if (selectedUpdateOrDeleteItem?.contentType === 'WEBPAGE') {
                    if(!addItemQSURLInput.includes("embed")) {
                       setErrorText("Please enter a valid Embeddable Quicksight dashboard URL")
                       return 
                    }
                }
                setShowLoadingIcon(true)
                let content = {}
                content["url"] = addItemQSURLInput
                content["description"] = cleanItemContent(addItemDescriptionInput)


                content = JSON.stringify(content)
                content = content.replaceAll('"', "'")
                const input = { "board_item_id": selectedUpdateOrDeleteItem?.value, "board_item_title": addItemTitleInput, "board_item_content": content, "last_updated_by": currentUser }
                await updateBoardItem(input, function onSuccess(result) {
                    const foundIndex = currentCarouselItems?.findIndex((i) => i.id === selectedUpdateOrDeleteItem?.value)
                    if (foundIndex !== -1) {
                        updateOnCarousel(selectedUpdateOrDeleteItem?.value,addItemTitleInput, addItemDescriptionInput)
                    }
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedResourceType()
                    setSelectedUpdateOrDeleteItem()
                    setSelectedSegmentId('add')
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    setAddItemQSURLInput()
                    setErrorText()
                    if (foundIndex === -1) {
                        loadData()
                        configureGenericAppSync()
                    }
                    
                }, function onFailure(response) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedUpdateOrDeleteItem()
                    setSelectedSegmentId('add')
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    configureGenericAppSync()
                    setShowLoadingIcon(false)
                })

            } else if (selectedUpdateOrDeleteItem?.contentType === 'EXTERNAL-LINK' && addItemLinkInput && addItemTitleInput) {
                setShowLoadingIcon(true)

                let content = {}
                content["link"] = addItemLinkInput

                content = JSON.stringify(content)
                content = content.replaceAll('"', "'")
                const input = { "board_item_id": selectedUpdateOrDeleteItem?.value, "board_item_title": addItemTitleInput, "board_item_content": content, "last_updated_by": currentUser }

                await updateBoardItem(input, function onSuccess(result) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedResourceType()
                    setSelectedUpdateOrDeleteItem()
                    setSelectedSegmentId('add')
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    setErrorText()
                    loadData()
                    configureGenericAppSync()
                }, function onFailure(response) {
                    setVisible(false)
                    setAddItemTitleInput()
                    setSelectedACApp()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setSelectedUpdateOrDeleteItem()
                    setNewSectionName()
                    setCreateNewSectionChecked(false)
                    setSelectedSegmentId('add')
                    configureGenericAppSync()
                    setShowLoadingIcon(false)
                })
            } else if ((selectedUpdateOrDeleteItem?.contentType === "WEBPAGE" && selectedUpdateOrDeleteItem?.currentContent?.url?.startsWith('https://')) && addItemLinkInput && addItemTitleInput) {
                const webResourceType = getWebResourcetype(addItemLinkInput)
                if(validateURLByWebResource(selectedUpdateOrDeleteItem?.currentContent?.url,webResourceType)) {
                    setShowLoadingIcon(true)

                    let content = {}
                    content["url"] = addItemLinkInput

                    content = JSON.stringify(content)
                    content = content.replaceAll('"', "'")
                    const input = { "board_item_id": selectedUpdateOrDeleteItem?.value, "board_item_title": addItemTitleInput, "board_item_content": content, "last_updated_by": currentUser }

                    await updateBoardItem(input, function onSuccess(result) {
                        setVisible(false)
                        setAddItemTitleInput()
                        setSelectedACApp()
                        setAddItemLinkInput()
                        setAddItemDescriptionInput()
                        setSelectedResourceType()
                        setSelectedUpdateOrDeleteItem()
                        setNewSectionName()
                        setCreateNewSectionChecked(false)
                        setSelectedSegmentId('add')
                        setErrorText()
                        loadData()
                        configureGenericAppSync()
                    }, function onFailure(response) {
                        setVisible(false)
                        setAddItemTitleInput()
                        setSelectedACApp()
                        setAddItemLinkInput()
                        setAddItemDescriptionInput()
                        setSelectedUpdateOrDeleteItem()
                        setNewSectionName()
                        setCreateNewSectionChecked(false)
                        setSelectedSegmentId('add')
                        configureGenericAppSync()
                        setShowLoadingIcon(false)
                    })
                } else {
                    setErrorText('Please provide a valid URL with respect to the resource selected')
                }
            } else {
                setErrorText('All fields are required!')
            }

            } else {
                setErrorText('All fields are required!')
            }

    }

    const deleteItem = async () => {
        if (selectedUpdateOrDeleteItem?.value) {
            setShowLoadingIcon(true)
            await deleteBoardItem(selectedUpdateOrDeleteItem?.value, function onSuccess(result) {
                const foundIndex = currentCarouselItems?.findIndex((i) => i.id === selectedUpdateOrDeleteItem?.value)
                setVisible(false)
                setAddItemTitleInput()
                setSelectedACApp()
                setAddItemLinkInput()
                setAddItemDescriptionInput()
                setSelectedResourceType()
                setSelectedUpdateOrDeleteItem()
                setSelectedSegmentId('add')
                setNewSectionName()
                setCreateNewSectionChecked(false)
                setErrorText()
                if (foundIndex !== -1) {
                    unFeatureOnCarousel(selectedUpdateOrDeleteItem?.value)
                } else {
                    loadData()
                    configureGenericAppSync()
                }
                
            }, function onFailure(response) {
                setVisible(false)
                setAddItemTitleInput()
                setSelectedACApp()
                setAddItemLinkInput()
                setAddItemDescriptionInput()
                setSelectedUpdateOrDeleteItem()
                setSelectedSegmentId('add')
                setNewSectionName()
                setCreateNewSectionChecked(false)
                configureGenericAppSync()
                setShowLoadingIcon(false)
            })
        } else {
            setErrorText('Select resource to remove')
        }

    }

    const deleteMultipleItems = async () => {
        if (selectedMultipleDeleteItems && selectedMultipleDeleteItems?.length >= 1) {

            for (let index = 0; index<selectedMultipleDeleteItems?.length; index++) {
                const foundIndex = currentCarouselItems?.findIndex((i) => i.id === selectedMultipleDeleteItems[index]?.value)
                if (foundIndex !== -1) {
                    setErrorText('Some of the selected resources are featured on Carousel, please unfeature them before initiating delete')
                    return;
                }
            }

            setShowLoadingIcon(true)
            await deleteMultipleBoardItems(selectedMultipleDeleteItems, function onSuccess(result) {
                setVisible(false)
                setAddItemTitleInput()
                setSelectedACApp()
                setAddItemLinkInput()
                setAddItemDescriptionInput()
                setSelectedResourceType()
                setSelectedUpdateOrDeleteItem()
                setSelectedSegmentId('add')
                setNewSectionName()
                setCreateNewSectionChecked(false)
                setSelectedMultipleDeleteItems([])
                setErrorText()
                loadData()
                configureGenericAppSync()
                
                
            }, function onFailure(response) {
                setVisible(false)
                setAddItemTitleInput()
                setSelectedACApp()
                setAddItemLinkInput()
                setAddItemDescriptionInput()
                setSelectedUpdateOrDeleteItem()
                setSelectedSegmentId('add')
                setNewSectionName()
                setCreateNewSectionChecked(false)
                configureGenericAppSync()
                setSelectedMultipleDeleteItems([])
                setShowLoadingIcon(false)
            })
        } else {
            setErrorText('Select resource(s) to remove')
        }
    }

    const addOrUpdateSection = async () => {

        if((selectedSectionsSegmentId === 'add-section' && newSectionName && selectedOptionsToUpdateSection) || (selectedSectionsSegmentId === 'update-section' && selectedSectionToMoveTo && selectedOptionsToUpdateSection && selectedOptionsToUpdateSection?.length > 0)) {
            setShowLoadingIcon(true)
            let input = []
            selectedOptionsToUpdateSection?.forEach((option) => {
                let sectionInput = {}
                sectionInput["board_item_id"] = option?.value
                sectionInput["section"] = selectedSectionsSegmentId === 'add-section' ? newSectionName : selectedSectionToMoveTo?.value
                input.push(sectionInput)
            })
            await updateSections(input, function onSuccess(result) {
                setErrorText()
                setAddItemLinkInput()
                setAddItemDescriptionInput()
                setAddItemQSURLInput()
                setSelectedResourceType()
                setAddItemTitleInput()
                setSelectedACApp()
                setErrorText()
                setSelectedSection()
                setNewSectionName()
                setCreateNewSectionChecked(false)
                setSelectedOptionsToUpdateSection()
                setSelectedSectionToMoveTo()
                setSelectedSectionsSegmentId('add-section')
                setSelectedSegmentId('add')
                setVisible(false)
                loadData()
                configureGenericAppSync()
            }, function onFailure(response) {
                setErrorText()
                setAddItemLinkInput()
                setAddItemDescriptionInput()
                setAddItemQSURLInput()
                setSelectedResourceType()
                setAddItemTitleInput()
                setSelectedACApp()
                setErrorText()
                setSelectedSection()
                setNewSectionName()
                setCreateNewSectionChecked(false)
                setSelectedOptionsToUpdateSection()
                setSelectedSectionToMoveTo()
                setSelectedSectionsSegmentId('add-section')
                setSelectedSegmentId('add')
                setVisible(false)
                setShowLoadingIcon(false)
                configureGenericAppSync()
            })
        }  else {
            setErrorText('All fields are required!')
        }

    }


    const updateAnnouncemnet = async () => {
        if (boardItemAnnouncement) {
            setShowLoadingIcon(true)
            const input = { "id": selectedLeftItemToDisplay?.board_item_id, "announcement": boardItemAnnouncement, "last_updated_by": currentUser}
            await addOrUpdateBoardItemAnnouncement(input, function onSuccess(result) {
                setErrorText()
                setAnnouncementUpdateModalVisible(false)
                loadData()
                configureGenericAppSync()
            }, function onFailure(response) {
                setAnnouncementUpdateModalVisible(false)
                setShowLoadingIcon(false)
                configureGenericAppSync()
            })
        } else {
            setErrorText('Comment cannot be empty')
        }
    }

    const featureOnCarousel = async () => {
        setShowLoadingIcon(true)
            const jsonContent = JSON.parse(selectedLeftItemToDisplay?.board_item_content?.replaceAll("'", '"'))
            const description = jsonContent.hasOwnProperty('description') ? jsonContent.description : 'No Description available'
            const contentInput = {
                "id": selectedLeftItemToDisplay?.board_item_id,
                "page_type": props?.pageType,
                "title": selectedLeftItemToDisplay?.board_item_title,
                "description": cleanItemContent(description),
            }
            currentCarouselItems.push(contentInput)
            const items = {items : currentCarouselItems}
            let content = JSON.stringify(items)
            content = content.replaceAll('"', "'")
            const input = { "board_item_id": carousel?.board_item_id, "board_item_title": carousel?.board_item_title, "board_item_content": content, "last_updated_by": currentUser }
                await updateBoardItem(input, function onSuccess(result) {
                   setErrorText()
                   setCurrentCarouselItems(currentCarouselItems)
                   loadData()
                   configureGenericAppSync()
                }, function onFailure(response) {
                    setShowLoadingIcon(false)
                    configureGenericAppSync()
                })

    }

    const unFeatureOnCarousel = async (id = undefined) => {
        setShowLoadingIcon(true)
        let foundIndex;
        if(id) {
            foundIndex = currentCarouselItems?.findIndex((i) => i.id === id)
        } else {
            foundIndex = currentCarouselItems?.findIndex((i) => i.id === selectedLeftItemToDisplay?.board_item_id)
        }
        if (foundIndex === -1) {
            setShowLoadingIcon(false)
            return
        }
            currentCarouselItems.splice(foundIndex, 1)
            const items = {items : currentCarouselItems}
            let content = JSON.stringify(items)
            content = content.replaceAll('"', "'")
            const input = { "board_item_id": carousel?.board_item_id, "board_item_title": carousel?.board_item_title, "board_item_content": content, "last_updated_by": currentUser }
                await updateBoardItem(input, function onSuccess(result) {
                   setErrorText()
                   setCurrentCarouselItems(currentCarouselItems)
                   loadData()
                   configureGenericAppSync()
                }, function onFailure(response) {
                    setShowLoadingIcon(false)
                    configureGenericAppSync()
                })

    }

        const updateOnCarousel = async (id, title, description) => {
        setShowLoadingIcon(true)
        
        let foundIndex = currentCarouselItems?.findIndex((i) => i.id === id)
        if (foundIndex === -1) {
            setShowLoadingIcon(false)
            return
        }
        const contentInput = {
            "id": id,
            "page_type": props?.pageType,
            "title": title,
            "description": cleanItemContent(description),
        }
            currentCarouselItems.splice(foundIndex, 1, contentInput)
            const items = {items : currentCarouselItems}
            let content = JSON.stringify(items)
            content = content.replaceAll('"', "'")
            const input = { "board_item_id": carousel?.board_item_id, "board_item_title": carousel?.board_item_title, "board_item_content": content, "last_updated_by": currentUser }
                await updateBoardItem(input, function onSuccess(result) {
                   setErrorText()
                   setCurrentCarouselItems(currentCarouselItems)
                   loadData()
                   configureGenericAppSync()
                }, function onFailure(response) {
                    setShowLoadingIcon(false)
                    configureGenericAppSync()
                })

    }

    const setCarouselItems = async () => {
        let carouselItems = []
        const res = await getBoardItems("HOME", props?.owner?.value, tabTypes.LIST, function onSuccess(result) {
            let data = result.data.getBoardItemsRDS
            data = JSON.parse(data)
            let carousel = data?.filter((i)=> (i?.board_item_content_type === "CAROUSEL"))[0]
            if(carousel) {
                setCarousel(carousel)
                carouselItems = JSON.parse(carousel?.board_item_content?.replaceAll("'", '"'))?.items
                setCurrentCarouselItems(carouselItems)
            }

            configureGenericAppSync()
            
        }, function onFailure(response) {
            configureGenericAppSync()
        })
    }

    const pushResourceToTeams = async () => {
        if(selectedResourceToPush) {
             setShowLoadingIcon(true)

                let columnOffset = {
                    "4": 0,
                    "6": 0
                }
                columnOffset = JSON.stringify(columnOffset)
                columnOffset = columnOffset.replaceAll('"', "'")
                let content = {}
                content = JSON.stringify(selectedResourceToPush?.currentContent)
                content = content.replaceAll('"', "'")
                const isDefault = false
                const input = {
                    "board_item_title": selectedResourceToPush?.label,
                    "board_item_content": content,
                    "board_item_content_type": selectedResourceToPush?.contentType,
                    "is_default": isDefault,
                    "board_page_type": props?.pageType,
                    "created_by": currentUser,
                    "last_updated_by": currentUser,
                    "row_span": "2",
                    "column_span": "1",
                    "column_offset": columnOffset,
                    "row_order": items?.length + 1,
                    "section": selectedResourceToPush?.section,
                    "board_item_announcement": selectedResourceToPush.boardItemAnnouncement ? selectedResourceToPush.boardItemAnnouncement : '' 
                }
                await pushBoardItemToTeams(input, function onSuccess(result) {
                    setAdminResourceControlModalVisible(false)
                    setSelectedResourceToPush()
                    setErrorText()
                    loadData()
                    configureGenericAppSync()
                }, function onFailure(response) {
                    setAdminResourceControlModalVisible(false)
                    setSelectedResourceToPush()
                    setErrorText()
                    configureGenericAppSync()
                    setShowLoadingIcon(false)
                })
        }
        else {
            setErrorText('Select resource to push to teams')
        }
    }

    const queryApps = async () => {

        let mQry = `
                query MyQuery {
                  getAppsV2  {
                      ${TEMPLATE_APP.APP_NAME}
                      ${TEMPLATE_APP.APP_DESCRIPTION}
                      ${TEMPLATE_APP.APP_ID}
                      ${TEMPLATE_APP.URL}
                  }
                }  
                    `;
                let response = await API.graphql(graphqlOperation(mQry));
                let qResultJSON = response.data.getAppsV2;
                setApps(qResultJSON)
    }

    return (
        <>
            {showLoadingIcon === true ? <Box margin="xxl" padding="xxl" textAlign="center">
                <Spinner size="large" />
            </Box> : (showLoadingIcon === false && typeof (viewAccess) === 'boolean' && viewAccess === false) ? <>
                <ErrorComponent header="Access Denied" message={`User is not authorized to view this page.`} />
            </> :
                <>
                    <Modal
                        onDismiss={() => {
                            setVisible(false)
                            setAddItemLinkInput()
                            setAddItemDescriptionInput()
                            setAddItemQSURLInput()
                            setSelectedResourceType()
                            setAddItemTitleInput()
                            setErrorText()
                            setSelectedSection()
                            setNewSectionName()
                            setCreateNewSectionChecked(false)
                            setSelectedOptionsToUpdateSection()
                            setSelectedSectionToMoveTo()
                            setSelectedSectionsSegmentId('add-section')
                            setSelectedSegmentId('add')
                            setFile([])
                        }}
                        visible={visible}
                        footer={
                            <>
                                {errorText && (<span style={{ color: "#db0000" }}>{errorText}</span>)}
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant="link" onClick={
                                            () => {
                                                setAddItemLinkInput()
                                                setAddItemDescriptionInput()
                                                setAddItemQSURLInput()
                                                setSelectedResourceType()
                                                setAddItemTitleInput()
                                                setSelectedACApp()
                                                setErrorText()
                                                setSelectedSection()
                                                setNewSectionName()
                                                setCreateNewSectionChecked(false)
                                                setSelectedOptionsToUpdateSection()
                                                setSelectedSectionToMoveTo()
                                                setSelectedSectionsSegmentId('add-section')
                                                setSelectedSegmentId('add')
                                                setVisible(false)
                                                setFile([])
                                            }
                                        }>Cancel</Button>
                                        {selectedSegmentId === 'add' && (
                                            <Button variant="primary" onClick={addItem}>Add resource</Button>
                                        )}
                                        {selectedSegmentId === 'update' && (
                                            <Button variant="primary" onClick={updateItem}>Update resource</Button>
                                        )}
                                        {selectedSegmentId === 'delete' && (
                                            <Button variant="primary" onClick={deleteMultipleItems}>Remove resource</Button>
                                        )}
                                        {selectedSegmentId === 'sections' && selectedSectionsSegmentId === 'add-section' && (
                                            <Button variant="primary" onClick={addOrUpdateSection}>Add section</Button>
                                        )}
                                        {selectedSegmentId === 'sections' && selectedSectionsSegmentId === 'update-section' && (
                                            <Button variant="primary" onClick={addOrUpdateSection}>Update sections</Button>
                                        )}
                                    </SpaceBetween>
                                </Box>
                            </>
                        }
                        header="Modify"
                    >
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <SegmentedControl
                                selectedId={selectedSegmentId}
                                onChange={({ detail }) =>
                                    setSelectedSegmentId(detail.selectedId)
                                }
                                label="Modify"
                                options={[
                                    { text: "Add", id: "add", iconName: "add-plus" },
                                    { text: "Update", id: "update", iconName: "edit" },
                                    { text: "Remove", id: "delete", iconName: "remove" },
                                    { text: "Sections", id: "sections", iconName: "edit", disabled: sideSections?.length <= 0 }
                                ]}
                            />
                        </div>
                        {selectedSegmentId === "add" && (<>
                            <FormField
                                label="Resource type"
                            >
                                <Select
                                    selectedOption={selectedResourceType}
                                    onChange={({ detail }) =>
                                        setSelectedResourceType(detail.selectedOption)
                                    }
                                    options={[
                                        { label: "FGBSBI Quicksight Dashboard", value: "QUICKSIGHT" },
                                        { label: "Amazon-BI Quicksight Dashboard", value: "AMAZON-BI-QS" },
                                        { label: "External Link", value: "EXTERNAL-LINK" },
                                        {label: "Accounting Central App", value: "ACCOUNTING-CENTRAL-APP"},
                                        {label: "Wiki Page", value: "WIKI"},
                                        {label: "Amazon Broadcast", value: "BROADCAST"},
                                        {label: "Issues Ticket", value: "SIM"},
                                        {label: "Cedric Persona", value: "CEDRIC-PERSONA"},
                                        {label: "PDF Document", value: "PDF"},
                                        {label: "Amazon News", value: "AMAZON_NEWS"},
                                        {label: "Magnify", value: "MAGNIFY"},
                                        {label: "Allocations", value: "ALLOCATIONS"},
                                        {label: "Report Central", value: "REPORT_CENTRAL"},
                                        {label: "First Pass PRO", value: "FIRST_PASS_PRO"},
                                        {label: "Boffin", value: "BOFFIN"},
                                        {label: "TED", value: "TED"},
                                        {label: "SEC Central", value: "SEC_CENTRAL"},
                                        {label: "Accounting Central Resource", value: "ACR"},
                                        {label: "Webpage Resource", value: "WEBPAGE", disabled: !isPortalAdmin, disabledReason: "Only available for Portal Admins"}
                                    ]}
                                    placeholder='Select resource type'
                                />
                            </FormField>
                            <FormField
                                label="Display name"
                            >
                                <Input onChange={({ detail }) => setAddItemTitleInput(detail.value)}
                                    value={addItemTitleInput}
                                    placeholder='Display name'
                                />
                            </FormField>
                            {(selectedResourceType?.value === 'QUICKSIGHT' || selectedResourceType?.value === 'AMAZON-BI-QS')  && (
                                <>
                                    <FormField
                                        label={selectedResourceType?.value === 'QUICKSIGHT' ? "Dashboard URL" : "Embeddable Dashboard URL"}
                                    >
                                        <Input onChange={({ detail }) => setAddItemQSURLInput(detail.value)}
                                            value={addItemQSURLInput}
                                            placeholder={selectedResourceType?.value === 'QUICKSIGHT' ? "Dashboard URL" : "Embeddable Dashboard URL"}
                                        />
                                    </FormField>
                                    <FormField
                                        label="Description"
                                    >
                                        <Textarea
                                            onChange={({ detail }) => setAddItemDescriptionInput(detail.value)}
                                            value={addItemDescriptionInput}
                                            placeholder="Description"
                                        />
                                    </FormField>
                                </>
                            )}
                            {selectedResourceType?.value === 'EXTERNAL-LINK' && (
                                <FormField
                                    label="Link"
                                >
                                    <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                        value={addItemLinkInput}
                                        placeholder='Provide full URL, including https://'
                                    />
                                </FormField>
                            )}
                            {selectedResourceType?.value === 'ACCOUNTING-CENTRAL-APP' && (
                                <FormField
                                    label="App"
                                >
                                    <Select
                                        selectedOption={selectedACApp}
                                        onChange={({ detail }) =>
                                            setSelectedACApp(detail.selectedOption)
                                        }
                                        options={apps.map((app) => {
                                            return { label: app?.app_name, value: app?.app_id, customURL: app?.url}
                                        })}
                                        placeholder='Select app'
                                        statusType={apps?.length <= 0 ? "loading" : "finished"}
                                        filteringType="auto"
                                        loadingText="Loading apps"
                                        empty="No valid app to recommend for entered text"
                                        virtualScroll={true}
                                        // onLoadItems ={({detail})=>{
                              
                                        // queryApps(detail?.filteringText)
                              
                                        // }}
                                    />
                                </FormField>
                            )}

                            {selectedResourceType?.value === 'WIKI' && (
                                <FormField
                                    label="Wiki URL"
                                >
                                    <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                        value={addItemLinkInput}
                                        placeholder='Provide a valid Wiki URL (https://w.amazon.com/)'
                                    />
                                </FormField>
                            )}

                            {selectedResourceType?.value === 'MAGNIFY' && (
                                <FormField
                                    label="Magnify URL"
                                >
                                    <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                        value={addItemLinkInput}
                                        placeholder='Provide a valid Magnify URL (https://prod.magnify.fintech.amazon.dev/)'
                                    />
                                </FormField>
                            )}
    
                            {selectedResourceType?.value === 'ACR' && (
                                <FormField
                                    label="Accounting Central Resource URL"
                                >
                                    <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                        value={addItemLinkInput}
                                        placeholder='Provide a valid Accounting Central URL'
                                    />
                                </FormField>
                            )}

                            {selectedResourceType?.value === 'WEBPAGE' && (
                                <FormField
                                    label="Webpage URL"
                                >
                                    <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                        value={addItemLinkInput}
                                        placeholder='Provide a valid Embeddable Web URL (starts with, https://)'
                                    />
                                </FormField>
                            )}

                            {selectedResourceType?.value === 'SIM' && (
                                <FormField
                                    label="Issues ticket URL"
                                >
                                    <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                        value={addItemLinkInput}
                                        placeholder='Provide a valid Sim ticket URL (https://issues.amazon.com/)'
                                    />
                                </FormField>
                            )}

                            {selectedResourceType?.value === 'BROADCAST' && (
                                <FormField
                                    label="Broadcast video URL"
                                >
                                    <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                        value={addItemLinkInput}
                                        placeholder='Provide a valid Broadcast video URL (https://broadcast.amazon.com/videos/<video-id>)'
                                    />
                                </FormField>
                            )}

                            {selectedResourceType?.value === 'CEDRIC-PERSONA' && (
                                <FormField
                                    label="Cedric Persona"
                                >
                                    <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                        value={addItemLinkInput}
                                        placeholder='Provide a valid Cedric Persona URL (https://console.harmony.a2z.com/internal-ai-assistant?persona=<id>)'
                                    />
                                </FormField>
                            )}

                            {selectedResourceType?.value === 'PDF' && (
                                <FormField
                                    label="PDF Document"
                                >
                                    <FileUpload
                                        onChange={({ detail }) => setFile(detail.value)}
                                        value={file}
                                        i18nStrings={{
                                        uploadButtonText: e =>
                                            e ? "Choose files" : "Choose file",
                                        dropzoneText: e =>
                                            e
                                            ? "Drop files to upload"
                                            : "Drop file to upload",
                                        removeFileAriaLabel: e =>
                                            `Remove file ${e + 1}`,
                                        limitShowFewer: "Show fewer files",
                                        limitShowMore: "Show more files",
                                        errorIconAriaLabel: "Error",
                                        warningIconAriaLabel: "Warning"
                                        }}
                                        showFileLastModified
                                        showFileSize
                                        showFileThumbnail
                                        tokenLimit={3}
                                        accept=".pdf"
                                        constraintText="Please select a PDF file"
                                    />
                                </FormField>
                            )}
                            <br></br>
                            {  
                                <Checkbox
                                onChange={({ detail }) =>
                                    setCreateNewSectionChecked(detail.checked)
                                }
                                checked={createNewSectionChecked}
                                readOnly={sideSections?.length <= 0}
                                >
                                    Create new section
                                </Checkbox>
                            }
                            
                            {sideSections?.length >= 1 && createNewSectionChecked === false &&(
                            <FormField
                            label="Section"
                            >
                                <Select
                                    selectedOption={selectedSection}
                                    onChange={({ detail }) =>
                                        setSelectedSection(detail.selectedOption)
                                    }
                                    options={sideSections}
                                    placeholder='Select section'
                                />
                            </FormField>
                            )}

                            {
                                (createNewSectionChecked === true || sideSections?.length <= 0) && (
                                    <FormField
                                        label="Section"
                                    >
                                        <Input onChange={({ detail }) => setNewSectionName(detail.value)}
                                            value={newSectionName}
                                            placeholder='Section'
                                        />
                                    </FormField>
                                )
                            }
                            


                        </>)}

                        {selectedSegmentId === "update" && (<>
                            <h3>
                                <span style={{ color: "#006ce0" }}>Update existing</span>
                            </h3>
                            <FormField
                                label="Resource to update"
                            >
                                <Select
                                    selectedOption={selectedUpdateOrDeleteItem}
                                    onChange={({ detail }) =>
                                        setSelectedUpdateOrDeleteItem(detail.selectedOption)
                                    }
                                    options={rawItems?.map((i) => {
                                        const currentContent = JSON.parse(i?.board_item_content?.replaceAll("'", '"'))
                                        return { "label": i?.board_item_title, "value": i?.board_item_id,"disabled": (i?.board_item_content_type === 'PDF' || Object.values(STATIC_RESOURCES).includes(currentContent?.url) || (((i?.board_item_content_type === 'WEBPAGE' && !isPortalAdmin) && !(currentContent?.url?.startsWith('https://w.amazon.com/') || currentContent?.url?.startsWith('https://broadcast.amazon.com/videos/') || currentContent?.url?.startsWith('https://issues.amazon.com/') || currentContent?.url?.startsWith('https://console.harmony.a2z.com/internal-ai-assistant?persona='))) &&
                                        (i?.board_item_content_type === 'WEBPAGE' && !(currentContent?.hasOwnProperty('description'))))) , disabledReason: "Few resources are disabled to update", contentType: i?.board_item_content_type, currentContent: currentContent }
                                    })}
                                    placeholder='Select resource to update'
                                />
                                {selectedUpdateOrDeleteItem?.contentType === 'EXTERNAL-LINK' && (
                                    <>
                                     <FormField
                                     label="Display name"
                                     >
                                    <Input onChange={({ detail }) => setAddItemTitleInput(detail.value)}
                                        value={addItemTitleInput}
                                        placeholder='Display name'
                                    />
                                    </FormField>
                                        <FormField
                                            label="Link"
                                        >
                                            <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                                value={addItemLinkInput}
                                                placeholder='Provide full URL, including https://'
                                            />
                                        </FormField>
                                    </>
                                )}
                                {(selectedUpdateOrDeleteItem?.contentType === 'QUICKSIGHT' || (selectedUpdateOrDeleteItem?.contentType === 'WEBPAGE' && selectedUpdateOrDeleteItem?.currentContent?.hasOwnProperty('description'))) && (
                                    <>
                                    <FormField
                                     label="Display name"
                                     >
                                    <Input onChange={({ detail }) => setAddItemTitleInput(detail.value)}
                                        value={addItemTitleInput}
                                        placeholder='Display name'
                                    />
                                    </FormField>

                                        <FormField
                                            label= { (selectedUpdateOrDeleteItem?.contentType === 'WEBPAGE' && selectedUpdateOrDeleteItem?.currentContent?.hasOwnProperty('description')) ? "Embeddable Dashboard URL" : "Dashboard URL"}
                                        >
                                            <Input onChange={({ detail }) => setAddItemQSURLInput(detail.value)}
                                                value={addItemQSURLInput}
                                                placeholder= { (selectedUpdateOrDeleteItem?.contentType === 'WEBPAGE' && selectedUpdateOrDeleteItem?.currentContent?.hasOwnProperty('description')) ? "Embeddable Dashboard URL" : "Dashboard URL"}
                                            />
                                        </FormField>
                                        <FormField
                                            label="Description"
                                        >
                                            <Textarea
                                                onChange={({ detail }) => setAddItemDescriptionInput(detail.value)}
                                                value={addItemDescriptionInput}
                                                placeholder="Description"
                                            />
                                        </FormField>
                                    </>
                                )}

                                {selectedUpdateOrDeleteItem?.contentType === 'WEBPAGE' && !selectedUpdateOrDeleteItem?.currentContent?.hasOwnProperty('description') && (
                                    <>
                                     <FormField
                                     label="Display name"
                                     >
                                    <Input onChange={({ detail }) => setAddItemTitleInput(detail.value)}
                                        value={addItemTitleInput}
                                        placeholder='Display name'
                                    />
                                    </FormField>
                                        <FormField
                                            label="URL"
                                        >
                                            <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                                value={addItemLinkInput}
                                                placeholder='Provide a valid and full URL, including https://'
                                            />
                                        </FormField>
                                    </>
                                )}

                            </FormField>

                        </>)}
                        {selectedSegmentId === "delete" && (<>
                            <h3>
                                <span style={{ color: "#006ce0" }}>Remove existing</span>
                            </h3>
                            <FormField
                                label="Resource(s) to remove"
                            >
                                <Multiselect
                                    selectedOptions={selectedMultipleDeleteItems}
                                    onChange={({ detail }) =>
                                        setSelectedMultipleDeleteItems(detail.selectedOptions)
                                    }
                                    options={rawItems?.map((i) => (
                                        { "label": i?.board_item_title, "value": i?.board_item_id, contentType: i?.board_item_content_type, currentContent: JSON.parse(i?.board_item_content?.replaceAll("'", '"')) }
                                    ))}
                                    placeholder='Select resource(s) to remove'
                                />
                            </FormField>

                        </>)}

                        {selectedSegmentId === "sections" && (<>
                        <br></br>
                        <br></br>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            
                            <SegmentedControl
                                selectedId={selectedSectionsSegmentId}
                                onChange={({ detail }) =>
                                    setSelectedSectionsSegmentId(detail.selectedId)
                                }
                                label="Modify sections"
                                options={[
                                    { text: "Add section", id: "add-section", iconName: "add-plus" },
                                    { text: "Update section", id: "update-section", iconName: "edit" }
                                ]}
                            />
                        </div>
                        
                        {selectedSectionsSegmentId === "add-section" && (<>
                            <h3>
                                <span style={{ color: "#006ce0" }}>Add new section</span>
                            </h3>
                            <FormField
                                label="Section name"
                            >
                                <Input onChange={({ detail }) => setNewSectionName(detail.value)}
                                    value={newSectionName}
                                    placeholder='Provide a section name'
                                />
                            </FormField>
                            <FormField
                                label="Resources to move to new section"
                            >
                            <Multiselect
                                selectedOptions={selectedOptionsToUpdateSection}
                                onChange={({ detail }) =>
                                    setSelectedOptionsToUpdateSection(detail.selectedOptions)
                                }
                                options={rawItems?.map((i) => (
                                    { "label": i?.board_item_title, "value": i?.board_item_id }
                                ))}
                                filteringType="auto"
                                placeholder="Choose options"
                            />
                            </FormField>
                        </>)}
                        {selectedSectionsSegmentId === "update-section" && (<>
                            <h3>
                                <span style={{ color: "#006ce0" }}>Update existing section</span>
                            </h3>
                            <FormField
                                label="Move resources from"
                            >
                                <Select
                                    selectedOption={selectedSection}
                                    onChange={({ detail }) =>
                                        setSelectedSection(detail.selectedOption)
                                    }
                                    options={sideSections}
                                    placeholder='Select section to update'
                                />
                            </FormField>

                            
                            {
                                selectedSection && (
                                    <FormField
                                        label="Resources to move to new section"
                                    >
                                    <Multiselect
                                        selectedOptions={selectedOptionsToUpdateSection}
                                        onChange={({ detail }) =>
                                            setSelectedOptionsToUpdateSection(detail.selectedOptions)
                                        }
                                        options={allGroupedItems[selectedSection?.value]?.map((i) => (
                                            { "label": i?.board_item_title, "value": i?.board_item_id }
                                        ))}
                                        filteringType="auto"
                                        placeholder="Choose options"
                                    />
                                    </FormField>
                                )
                            }

                            <FormField
                                label="Move resources to"
                            >
                                <Select
                                    selectedOption={selectedSectionToMoveTo}
                                    onChange={({ detail }) =>
                                        setSelectedSectionToMoveTo(detail.selectedOption)
                                    }
                                    options={sideSections}
                                    placeholder='Select section to update'
                                />
                            </FormField>
                            
                            
                        </>)}
                        </>)}

                    </Modal>
                    <Modal
                    onDismiss={() => {
                            setAnnouncementUpdateModalVisible(false)
                            setErrorText()
                        }}
                        visible={announcementUpdateModalVisible}
                        footer={
                            <>
                                {errorText && (<span style={{ color: "#db0000" }}>{errorText}</span>)}
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant="link" onClick={
                                            () => {
                                                setAnnouncementUpdateModalVisible(false)
                                                setErrorText()
                                            }
                                        }>Cancel</Button>
                                        
                                        <Button variant="primary" onClick={updateAnnouncemnet}>Update</Button>
                                        
                                    </SpaceBetween>
                                </Box>
                            </>
                        }
                        header="Provide information about this resource"
                    >
                        <FormField
                        label="Info"
                        >
                            <Textarea
                                onChange={({ detail }) => setBoardItemAnnouncement(detail.value)}
                                value={boardItemAnnouncement}
                                placeholder="Add information about this resource"
                            />
                        </FormField>
                    </Modal>
                    <Modal
                    onDismiss={() => {
                            setAdminResourceControlModalVisible(false)
                            setSelectedResourceToPush()
                            setErrorText()
                        }}
                        footer = {
                            <>
                                {errorText && (<span style={{ color: "#db0000" }}>{errorText}</span>)}
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant="link" onClick={
                                            () => {
                                                setAdminResourceControlModalVisible(false)
                                                setSelectedResourceToPush()
                                                setErrorText()
                                            }
                                        }>Cancel</Button>
                                        
                                        <Button variant="primary" onClick={pushResourceToTeams}>Push to all Teams</Button>
                                        
                                    </SpaceBetween>
                                </Box>
                            </>
                        } 
                        visible={adminResourceControlModalVisible}
                        >
                            <FormField
                                label="Resource to push to all teams"
                            >
                                <Select
                                    selectedOption={selectedResourceToPush}
                                    onChange={({ detail }) =>
                                        setSelectedResourceToPush(detail.selectedOption)
                                    }
                                    options={rawItems?.map((i) => (
                                        { "label": i?.board_item_title, "value": i?.board_item_id, contentType: i?.board_item_content_type, currentContent: JSON.parse(i?.board_item_content?.replaceAll("'", '"')), section: i?.section, boardItemAnnouncement: i?.board_item_announcement }
                                    ))}
                                    placeholder='Select resource to push'
                                />
                            </FormField>
                        </Modal>
                    <Grid
                        gridDefinition={gridDefinitions}
                    >
                        {!leftMenuCollapsed && (
                            <Container
                            header={
                                <Header
                                    variant="h2"
                                    actions={
                                        <span style={{cursor: "pointer"}} onClick={()=>{setLeftMenuCollapsed(true)}}>
                                        <Icon
                                        name="angle-left-double"
                                        size="medium"
                                        variant="normal"
                                        />
                                        </span>
                                    }
                                >
                                Resources    
                                </Header>
                            }
                        >
                            <SideNavigation
                                activeHref={activeHref}
                                onFollow={event => {
                                    if (!event.detail.external) {
                                        event.preventDefault();
                                        setActiveHref(event.detail.href);
                                    }
                                }}
                                items={items}
                            />
                            <SpaceBetween direction='horizontal' size='m' alignItems='center'>
                            {isPortalAdmin && selectedOwner?.owner_type === "DEFAULT" && (
                                <span style={{cursor: "pointer"}} onClick={()=>{setAdminResourceControlModalVisible(true)}}>
                                    <Icon
                                    name="settings"
                                    size="medium"
                                    variant="normal"
                                    />
                                </span>
                            )}
                            {addOrEditAccess && (
                                <Button iconAlign="right" iconName="edit" onClick={() => {
                                    if(sideSections?.length <=0) {
                                        setCreateNewSectionChecked(true)
                                    }
                                    setVisible(true)
                                    queryApps()
                                }}>
                                    Edit
                                </Button>
                            )}
                            </SpaceBetween>
                            
                            
                        </Container>
                        )}
                        
                        <SpaceBetween size="l">
                            {addOrEditAccess && activeHref && selectedLeftItemToDisplay &&
                            selectedLeftItemToDisplay.board_item_content_type === 'QUICKSIGHT' && (
                            currentCarouselItems?.find((i)=>i?.id === selectedLeftItemToDisplay.board_item_id) ? 
                            <Button onClick={() => {
                                unFeatureOnCarousel()
                            }}>
                             Unfeature on Home page
                            </Button> : 
                            <Button onClick={featureOnCarousel}>
                             Feature on Home page
                            </Button> 
                        )}
                        {leftMenuCollapsed && (
                            <span style={{cursor: "pointer"}} onClick={()=>{setLeftMenuCollapsed(false)}}>
                            <Icon
                            name="angle-right-double"
                            size="medium"
                            variant="normal"
                            />
                        </span>
                        )}
                               
                        <Container
                            fitHeight
                            header={
                                <Header
                                    variant="h2"
                                    actions={
                                        <SpaceBetween direction='horizontal' size='m'>
                                            {(selectedLeftItemToDisplay?.board_item_content_type === 'QUICKSIGHT' || selectedLeftItemToDisplay?.board_item_content_type === 'WEBPAGE') && (
                                            <Button
                                            ariaLabel="Open externally (opens new tab)"
  		                                    href={JSON.parse(selectedLeftItemToDisplay?.board_item_content?.replaceAll("'", '"'))?.url}
                                            iconAlign="right"
                                            iconName="external"
                                            target="_blank"
                                            >
                                        </Button>
                                            )}
                                        <Button onClick={() => {
                                        loadData(activeHref)
                                        }} iconAlign="right" iconName="refresh">
                                        </Button>
                                        </SpaceBetween>
                                    }
                                >

                                </Header>
                            }
                        >
                            {!activeHref && (
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="text-body-secondary"
                                >
                                    <SpaceBetween size="m">
                                        <Box variant="strong" color="inherit">
                                            Please select a resource on left
                                        </Box>
                                    </SpaceBetween>
                                </Box>
                            )}
                            {activeHrefContent}
                            <br></br>
                            <br></br>
                            {selectedLeftItemToDisplay?.board_item_announcement && (
                            <>
                            <div className='cp-comment-box-grey'>
                                {selectedLeftItemToDisplay?.board_item_announcement?.split("\n").map((str)=>{
                                    return (<>
                                    {str}
                                    <br></br>
                                    </>)
                                })}
                            </div>
                            
                            <br></br>
                            <br></br>
                            </>
                            )}
                            
                            {addOrEditAccess && activeHref && (
                                <Button iconAlign="right" iconName="edit" onClick={() => {
                                    setAnnouncementUpdateModalVisible(true)
                                }}>
                                   {selectedLeftItemToDisplay?.board_item_announcement ? "Edit comment" : "Add comment"}
                                </Button>
                            )}
                        </Container>
                        </SpaceBetween>

                    </Grid>
                </>
            }
        </>
    );
}

export default CustomMultipleResourcePage;
